import React from "react";

import { FormLabel } from "~/components/form/label";
import { FormFieldReset } from "~/components/form/reset";

import { Widget, WidgetBody, WidgetHeader } from "../../../_widget";
import { WidgetConnectNullsField } from "../../../widget-form/connect-nulls";
import { SettingsSectionFormField } from "../_field";
import { LegendSection } from "../_legend/section";
import { ResetToDefaultSection } from "../_reset-to-default-section";
import { SettingsSectionGrid } from "../_section-grid";
import { ThresholdsSection } from "../_thresholds/section";
import { YAxisLabelsSection } from "../_y-axis/labels-section";
import { YAxisRangeSection } from "../_y-axis/range-section";

import { FormState } from "./form-state";

export interface TimeSeriesChartSettingsProps {
	settings: FormState;
}

export const TimeSeriesChartSettings: React.FC<TimeSeriesChartSettingsProps> = ({ settings }) => (
	<div className="grid h-full grid-cols-3 gap-4">
		<div className="flex flex-col gap-4">
			<LegendSection legend={settings.fields.legend} />

			<Widget>
				<WidgetHeader className="uppercase" title="Visual">
					<FormFieldReset className="ml-auto" state={settings.fields.connectNulls} />
				</WidgetHeader>

				<WidgetBody card>
					<SettingsSectionGrid className="grid-cols-[auto_1fr]">
						<SettingsSectionFormField layout="horizontal" state={settings.fields.connectNulls}>
							<FormLabel>Connect Nulls</FormLabel>

							<WidgetConnectNullsField
								connectNulls={settings.fields.connectNulls}
								name="dashboard-widget-settings-connect-nulls"
							/>
						</SettingsSectionFormField>
					</SettingsSectionGrid>
				</WidgetBody>
			</Widget>
		</div>

		<div className="flex flex-col gap-4">
			<YAxisLabelsSection yAxis={settings.fields.yAxis} />

			<YAxisRangeSection range={settings.fields.range} />
		</div>

		<div className="flex flex-col gap-4">
			<Widget>
				<WidgetHeader className="uppercase" title="Thresholds">
					<FormFieldReset className="ml-auto" state={settings.fields.thresholds} />
				</WidgetHeader>

				<WidgetBody card>
					<ThresholdsSection
						mode={settings.fields.thresholds.fields.mode}
						thresholds={settings.fields.thresholds.fields.steps}
					/>
				</WidgetBody>
			</Widget>

			<ResetToDefaultSection onClick={() => FormState.resetToDefault(settings)} />
		</div>
	</div>
);
